import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { isEmpty } from 'lodash-es';

import { ChangeUserDetailsRequest } from '@vi-iot/client';

import { PATTERN } from '@common';
import { ContactDetailsFormGroup } from './contact-details.helper';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactDetailsComponent implements OnInit {
  formGroup: FormGroup<ContactDetailsFormGroup>;

  @Input() details: {
    phoneNumber: string;
    mobileNumber: string;
  };

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  @Output() save: EventEmitter<ChangeUserDetailsRequest> = new EventEmitter<
    ChangeUserDetailsRequest
  >();

  ngOnInit(): void {
    this.formGroup = new FormGroup<ContactDetailsFormGroup>({
      telephone: new FormControl<string>(this.details.phoneNumber, [
        Validators.pattern(PATTERN.PHONE),
        Validators.minLength(9),
      ]),
      mobile: new FormControl<string>(this.details.mobileNumber, [
        Validators.pattern(PATTERN.PHONE),
        Validators.minLength(9),
      ]),
    });
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onSave(): void {
    const value = this.formGroup.value;
    const payload: ChangeUserDetailsRequest = {
      contacts: {
        telephone: value.telephone?.trim(),
        mobile: value.mobile?.trim(),
      },
    };

    if (isEmpty(payload)) {
      this.onCancel();
    } else {
      this.save.emit(payload);
    }
  }
}
